import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { NavLink } from 'react-router-dom';

import Tooltip from '../Tooltip';

const Nav = styled.nav`
  display: flex;
  height: 42px;
`;

const Tab = styled(NavLink)`
  color: ${themeGet('colors.black.80')};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  padding: 8px 10px 15px;
  margin: 0 9px 0 0;

  &:last-child {
    margin: 0;
  }
  &.active {
    color: ${themeGet('colors.primary.100')};
    border-bottom: solid 2px ${themeGet('colors.primary.100')};
  }
  &:hover {
    color: ${themeGet('colors.primary.80')};
  }
  &:active {
    color: ${themeGet('colors.primary.120')};
  }
`;

const LockedTab = styled.div`
  color: ${themeGet('colors.black.80')};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  padding: 8px 10px 15px;
  margin: 0 9px 0 0;
  cursor: not-allowed;
  opacity: 0.5;

  &:first-child {
    border-bottom: solid 2px ${themeGet('colors.primary.50')};
  }

  &:last-child {
    margin: 0;
  }
`;

const BasicTab = ({ name, to, exact }) => {
  return (
    <Tab key={name} exact={exact} to={to}>
      {name}
    </Tab>
  );
};

const DisabledTab = ({ name, tooltip }) => {
  return (
    <LockedTab key={name} data-tip={tooltip}>
      {name}
    </LockedTab>
  );
};

export default function TabNavigation({ tabs }) {
  return (
    <Nav>
      <Tooltip />
      {tabs.map(({ name, to, exact, disabled = false, tooltip }) => {
        if (disabled)
          return <DisabledTab key={name} name={name} tooltip={tooltip} />;

        return <BasicTab key={name} name={name} to={to} exact={exact} />;
      })}
    </Nav>
  );
}
